/* tslint:disable */
/* eslint-disable */
/**
 * Committee Management API
 * The Law Society Committee Management Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddressTypeIEnumerableResponse } from '../models';
import { BuildingTypeIEnumerableResponse } from '../models';
import { CommitteeRoleIEnumerableResponse } from '../models';
import { CommitteeViewIEnumerableResponse } from '../models';
import { CountryIEnumerableResponse } from '../models';
import { DeliveryTypeIEnumerableResponse } from '../models';
import { DxExchangeIEnumerableResponse } from '../models';
import { EoiFormStatusIEnumerableResponse } from '../models';
import { FileTypeIEnumerableResponse } from '../models';
import { MeetingTypeIEnumerableResponse } from '../models';
import { MembershipTypeIEnumerableResponse } from '../models';
import { RelationshipCategoryIEnumerableResponse } from '../models';
import { RelationshipTypeIEnumerableResponse } from '../models';
import { Request } from '../models';
import { StreetTypeIEnumerableResponse } from '../models';
import { StringCodeViewDictionaryResponse } from '../models';
import { SuburbStatePostcodeIEnumerableResponse } from '../models';
/**
 * CodeApi - axios parameter creator
 * @export
 */
export const CodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetAddressTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetAddressTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Building Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetBuildingTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetBuildingTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Codes for CMA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCodesForCmaGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetCodesForCma`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Committee Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteeRolesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetCommitteeRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesForFastTrackGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetCommitteesForFastTrack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track by yearId
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesForFastTrackYearIdGet: async (yearId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CodeGetCommitteesForFastTrackYearIdGet.');
            }
            const localVarPath = `/api/v1/Code/GetCommitteesForFastTrack/{yearId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Committees (Current Year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetCommittees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Countries (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCountriesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetCountries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Delivery Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetDeliveryTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetDeliveryTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns DX Exchange list  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetDxExchangeListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetDxExchangeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetEoiFormStatusForFastTrackGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetEoiFormStatusForFastTrack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetEoiFormStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetEoiFormStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetFileTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetFileTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetMeetingTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetMeetingTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetMembershipTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetMembershipTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Relationship Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetRelationshipCategoriesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetRelationshipCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Relationship Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetRelationshipTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetRelationshipTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Street Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetStreetTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetStreetTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Postcode (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetSuburbStatePostcodeByPostcodePost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetSuburbStatePostcodeByPostcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Suburb Name (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetSuburbStatePostcodeBySuburbPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Code/GetSuburbStatePostcodeBySuburb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeApi - functional programming interface
 * @export
 */
export const CodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetAddressTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetAddressTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Building Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetBuildingTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetBuildingTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Codes for CMA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCodesForCmaGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringCodeViewDictionaryResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCodesForCmaGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Committee Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCommitteeRolesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeRoleIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCommitteeRolesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCommitteesForFastTrackGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCommitteesForFastTrackGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track by yearId
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Committees (Current Year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCommitteesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCommitteesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Countries (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetCountriesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetCountriesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Delivery Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetDeliveryTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetDeliveryTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns DX Exchange list  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetDxExchangeListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DxExchangeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetDxExchangeListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetEoiFormStatusForFastTrackGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EoiFormStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetEoiFormStatusForFastTrackGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetEoiFormStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EoiFormStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetEoiFormStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetFileTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetFileTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetMeetingTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetMeetingTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetMembershipTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetMembershipTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Relationship Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetRelationshipCategoriesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipCategoryIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetRelationshipCategoriesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Relationship Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetRelationshipTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetRelationshipTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Street Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetStreetTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreetTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetStreetTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Postcode (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetSuburbStatePostcodeByPostcodePost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuburbStatePostcodeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetSuburbStatePostcodeByPostcodePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Suburb Name (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CodeGetSuburbStatePostcodeBySuburbPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuburbStatePostcodeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV1CodeGetSuburbStatePostcodeBySuburbPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CodeApi - factory interface
 * @export
 */
export const CodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetAddressTypesGet(options?: any): AxiosPromise<AddressTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetAddressTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Building Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetBuildingTypesGet(options?: any): AxiosPromise<BuildingTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetBuildingTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Codes for CMA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCodesForCmaGet(options?: any): AxiosPromise<StringCodeViewDictionaryResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCodesForCmaGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Committee Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteeRolesGet(options?: any): AxiosPromise<CommitteeRoleIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCommitteeRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesForFastTrackGet(options?: any): AxiosPromise<CommitteeViewIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCommitteesForFastTrackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committees for fast track by yearId
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId: number, options?: any): AxiosPromise<CommitteeViewIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Committees (Current Year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCommitteesGet(options?: any): AxiosPromise<CommitteeViewIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCommitteesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Countries (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetCountriesGet(options?: any): AxiosPromise<CountryIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetCountriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Delivery Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetDeliveryTypesGet(options?: any): AxiosPromise<DeliveryTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetDeliveryTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns DX Exchange list  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetDxExchangeListGet(options?: any): AxiosPromise<DxExchangeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetDxExchangeListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status for fast track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetEoiFormStatusForFastTrackGet(options?: any): AxiosPromise<EoiFormStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetEoiFormStatusForFastTrackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Eoi Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetEoiFormStatusGet(options?: any): AxiosPromise<EoiFormStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetEoiFormStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetFileTypesGet(options?: any): AxiosPromise<FileTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetFileTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Address Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetMeetingTypesGet(options?: any): AxiosPromise<MeetingTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetMeetingTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetMembershipTypesGet(options?: any): AxiosPromise<MembershipTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetMembershipTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Relationship Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetRelationshipCategoriesGet(options?: any): AxiosPromise<RelationshipCategoryIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetRelationshipCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Relationship Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetRelationshipTypesGet(options?: any): AxiosPromise<RelationshipTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetRelationshipTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Street Types  (via LS API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetStreetTypesGet(options?: any): AxiosPromise<StreetTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetStreetTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Postcode (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetSuburbStatePostcodeByPostcodePost(body?: Request, options?: any): AxiosPromise<SuburbStatePostcodeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetSuburbStatePostcodeByPostcodePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns Suburb, State, Postcode By Suburb Name (via LS API)
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CodeGetSuburbStatePostcodeBySuburbPost(body?: Request, options?: any): AxiosPromise<SuburbStatePostcodeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV1CodeGetSuburbStatePostcodeBySuburbPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeApi - object-oriented interface
 * @export
 * @class CodeApi
 * @extends {BaseAPI}
 */
export class CodeApi extends BaseAPI {
    /**
     * 
     * @summary Reader | Returns Address Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetAddressTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetAddressTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Building Types  (via LS API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetBuildingTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetBuildingTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Codes for CMA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCodesForCmaGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCodesForCmaGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Committee Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCommitteeRolesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCommitteeRolesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Returns Committees for fast track
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCommitteesForFastTrackGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCommitteesForFastTrackGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Returns Committees for fast track by yearId
     * @param {number} yearId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId: number, options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCommitteesForFastTrackYearIdGet(yearId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Committees (Current Year)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCommitteesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCommitteesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Countries (via LS API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetCountriesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetCountriesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Delivery Types  (via LS API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetDeliveryTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetDeliveryTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns DX Exchange list  (via LS API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetDxExchangeListGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetDxExchangeListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Eoi Form Status for fast track
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetEoiFormStatusForFastTrackGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetEoiFormStatusForFastTrackGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Eoi Form Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetEoiFormStatusGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetEoiFormStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns File Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetFileTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetFileTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Address Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetMeetingTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetMeetingTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Membership Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetMembershipTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetMembershipTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Relationship Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetRelationshipCategoriesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetRelationshipCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Relationship Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetRelationshipTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetRelationshipTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Street Types  (via LS API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetStreetTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetStreetTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Suburb, State, Postcode By Postcode (via LS API)
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetSuburbStatePostcodeByPostcodePost(body?: Request, options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetSuburbStatePostcodeByPostcodePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns Suburb, State, Postcode By Suburb Name (via LS API)
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV1CodeGetSuburbStatePostcodeBySuburbPost(body?: Request, options?: any) {
        return CodeApiFp(this.configuration).apiV1CodeGetSuburbStatePostcodeBySuburbPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
